<div class="bottom-nav border-top-1 border-50">
    <div class="nav-item text-500 font-medium" *ngFor="let item of navItems" (click)="navigate(item)"
    [ngClass]="{'text-orange-500': selected == item.label}">
      <i [class]="item.icon" class="text-base mb-1"></i>
      <span class="text-xs">{{ item.label }}</span>
    </div>
  </div>
  